import http from '../../common/request';

/**
 * 获取开发者信息
 */
export function getUserInfo(data) {
  return http.get('/admin/user/findDetail', {
    params: data
  })
}

/**
 * 认证
 */
export function goAuth(data) {
  return http.post('/admin/auth/record/create', data)
}

/**
 * 修改开发者名称
 */
export function updateName(data) {
  return http.post('/admin/user/modify/base/info', data)
}

/**
 * 识别营业执照和企业名称
 */
export function getAuthInfo(data) {
  return http.post('/ocr/v1/enterprise-business-license', data)
}

/**
 * 获取修改密码短信验证码
 */
export function getPasswordCode(data) {
  return http.get('/admin/sms/singleSendSysCode', {
    params: data
  })
}

/**
 * 修改密码
 */
export function updatePassword(data) {
  return http.post('/admin/user/modify/password', data)
}